import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../style/Navigation.css";

const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/aboutus", label: "About Us" },
  { href: "/kotecafe", label: "Kote Cafe" },
  { href: "/gallery", label: "Gallery" },
  { href: "/franchise", label: "Franchise" },
  { href: "/faq", label: "FAQ" },
  { href: "/contactus", label: "Contact Us" },
  {
    href: "https://flip.bitbytefoods.com",
    label: "Flip Game",
    target: "_blank",
    rel: "noreferrer",
  },
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      sticky="top"
      variant="dark"
      className={`bbf-navbar ${scrolled ? "bbf-navbar--scrolled" : ""}`}
    >
      <Container fluid className="bbf-navbar__container">
        <Navbar.Brand href="/" className="bbf-navbar__brand">
          <img alt="Bit Byte Foods" src="/images/logo.png" width="110" height="55" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="bbf-nav" />
        <Navbar.Collapse id="bbf-nav">
          <Nav className="bbf-navbar__links">
            {NAV_LINKS.map((link) => (
              <Nav.Link
                key={link.href}
                href={link.href}
                target={link.target}
                rel={link.rel}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
